import { OtkList } from '../../models/user-item-list';
import { Record } from '../../models/record';
import { CreateListRequest, UpdateListRequest } from '../services/models/list.request';

export class OpenDialog {
  static readonly type = '[Edit list] Open dialog';

  constructor(public list?: OtkList, public record?: Record) {}
}

export class CloseDialog {
  static readonly type = '[Edit list] Close dialog';
}

export class UpdateLocalList {
  static readonly type = '[Edit list] Update list';

  constructor(public list: Partial<OtkList>) {}
}

export class CreateList {
  static readonly type = '[Edit list] Create list';

  constructor(public userId: string, public list: CreateListRequest, public record?: Record) {}
}

export class EditList {
  static readonly type = '[Edit list] Edit list';

  constructor(public list: UpdateListRequest) {}
}
